import { complement } from 'ramda';
import { hasNoItems } from './hasNoItems';

interface IHasItems {
  <T extends ReadonlyArray<any>>(array: Optional<T>): array is T;
  <T extends any[]>(array: Optional<T>): array is T;
}
/**
 * 주어진 배열이 nil이 아니고 비어있지 않은지 여부를 판별한다. MobX 배열에도 사용할 수 있다.
 * @param array 판별할 배열.
 * @return nil이거나 비어있으면 `false`, 아니면 `true`.
 */
export const hasItems = complement(hasNoItems) as IHasItems;
